export default __webpack_public_path__ + "static/media/videoConferencingSystem.11afe6f5.svg";